import React, { useState } from "react";
import Css from "../React/FrameReact.module.css";
import { Link } from "react-router-dom";
import FrameWorkImage from "../PackageImage/FrameWorkImage";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
const ParagraphComponent = ({ paragraph, id }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const maxLength = 140;
  const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
  };

  const shouldTruncate = paragraph.length > maxLength;
  const displayedText = isExpanded ? paragraph : paragraph.slice(0, maxLength);

  return (
    <p>
      {displayedText}
      {/* {span && <span className="ReadMore"> {}</span>} */}
      {shouldTruncate && (
        <button to={`${id}`} className="ReadMore" onClick={toggleReadMore}>
          {isExpanded ? " Read less" : " Read more..."}
        </button>
      )}
    </p>
  );
};
const FullStack = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 4;
  const products = [
       {
      id: 154,
      title: "Glory-Scout",
      FrameWork: "React.js & DotNet",
      paragraph:
        "An interactive platform for discovering football talents, developed using React.js and Tailwind CSS with .NET API integration. It dynamically displays player information with a responsive and smooth user experience, ensuring clear front-end and back-end collaboration.",
      span: "Responsive",
      Preview: "https://depi-mega-project-glory-scout-i5s7.vercel.app/",
      GitHub: "https://github.com/Ye7ia01/DEPI.Mega.Project.Glory.Scout",
      image: FrameWorkImage.GloryScout,
    },
    {
      id: 66,
      title: "Instagram",
      FrameWork: "React & Node Js",
      paragraph:
        "A login interface for a real-time chat application built using React and Sass. Features API integration for user authentication and secure login. Supports responsive design and provides a smooth, fast user experience.",
      span: "Responsive",
      Preview: "https://chat97.vercel.app/login",
      GitHub: "https://github.com/Mohamed-Adel0/Instagrams",
      image: FrameWorkImage.instagram,
    },
    {
      id: 12,
      title: "Bistro-Bliss",
      FrameWork: "React & Node Js",
      paragraph: "A fully integrated restaurant and cafe platform called Bistro Bliss with a modern design and smooth experience.Built using React.js for the frontend and Node.js + MongoDB for the backend.Includes API integration for displaying menus, reservations, and handling customer data.",
      span: "Responsive",
      Preview: "https://bistro-bliss97.netlify.app/",
      GitHub: "https://github.com/Mohamed-Adel0/BistroBliss-FullStack",
      image: FrameWorkImage.BistroBliss,
    },
    {
      id: 132,
      title: "Crud-Operation",
      FrameWork: "React Js",
      paragraph: "A full-featured CRUD system built with React.js. It includes product search, filtering by category, dark/light mode, and fully responsive design. Secured routes and all Axios methods (GET, POST, PUT, DELETE) are implemented for API interaction",
      span: "Responsive",
      Preview: "https://gig-crud-dashboard.vercel.app/",
      GitHub: "https://github.com/Mohamed-Adel0/CRUD-Dashboard",
      image: FrameWorkImage.CrudOpration,
    },
    
  ];
   const totalPages = Math.ceil(products.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentItems = products.slice(startIndex, startIndex + itemsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };
  return (
      <div>
      <div className={Css.container}>
        {currentItems.map((r) => (
          <div className={Css.cards} key={r.id}>
            <div className={Css.card}>
              <div className={Css.img}>
                <Link to={r.Preview} target="_blank">
                  <img src={r.image} alt="" />
                </Link>
              </div>
              <div className={Css.text}>
                <h2>
                  {r.title} <span>{r.FrameWork}</span>
                </h2>
                <ParagraphComponent paragraph={r.paragraph} id={r.id}/>
                <div className={Css.src}>
                  <Link target="_blank" to={r.Preview}>
                    Preview
                  </Link>
                  <Link target="_blank" to={r.GitHub}>
                    GitHub
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Pagination */}
      <div className="pagination">
        <button className="arrow" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
          <IoIosArrowBack/>
        </button>

        <div className="totalspaginations">
          {Array.from({ length: totalPages }, (_, i) => (
          <button
            key={i + 1}
            onClick={() => handlePageChange(i + 1)}
            className={currentPage === i + 1 ? "activeNumb" : ""}
          >
            {i + 1}
          </button>
        ))}
        </div>

        <button className="arrow" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
          <IoIosArrowForward/>
        </button>
      </div>
    </div>
  );
};

export default FullStack;
